import { atom } from 'jotai'
import { MutableRefObject } from 'react'

const statementsFlowRef: MutableRefObject<string> = { current: '' }

export const statementsFlowRefAtom = atom(statementsFlowRef)
